
/*------英文语音包------*/
export const lang = {
    home: "Home",
    zks: "Find a department",
    zys: "See a doctor", 
    bzzx: "Help Center",
    grzx: "My Center",
    zbch: "Without going out",
    zxspjz: "Online video visit",
    xzys: "Choose your doctor",
    txwzxx: "Fill in the information",
    zfghfy: "Pay the registered fee",
    ddysjh: "Wait for the doctor to call",
    wzjs: "End of the visits",
    ckyszd: "Check your doctor's diagnosis",
    xzwzzs: "Download the inquiry assistant",
    yjxz: "Click here to download and install",
    azwc: "After the installation, you can make a video visit to the doctor",
    twzx: "Graphic and text consultation",
    qbks: "All departments",
    zkmz: "Specialist out-patient department",
    syzn: "User Guide",
    yugh: "Appointment issues",
    jzxg: "Inquiry issues",
    zhxg: "Account issues",
    fwtk: "Terms of Service",
    qtwt: "Other Questions",
    zmy: "See an expert ",
    wlmz: "Network outpatient time",
    sw: "Morning",
    xw: "Afternoon",
    ws: "Night ",
    jt: "Today",
    mt: "Tomorrow",
    zk: "Expand",
    sq: "Fold",
    kssx: "Department screening",
    jzrq: "Visit date",
    jzsd: "Visit time ",
    qb: "All",
    yy: "Appointment ",
    zjyy: "Make appointment with experts ",
    yjz: "Under treatment ",
    ks: "Department",
    yishen: "Doctor", 
    zt: "Status",
    ghcg: "Registered successfully",
    ksjhh: "When it starts to call the numbers, there will be a text message for you, please keep your mobile phone unblocked",
    spwz: "Video visit",
    dycsy: "For the first time to use, please download the “inquiry assistant”",
    yaz: "If you have already finished installation, please go to the personal center to open video",
    dksp: "Open Video",
    ysjdksp: "Open video by mobile phone",
    jzr: "Patient",
    jzxh:  "Visit number",
    xb: "Gender",
    nl: "Age",
    sfzh: "Identity card number",
    sjh: "Mobile phone number",
    yiyuan: "Hospital",
    jzkh: "Medical card number",
    hzms: "Patients description",
    jws: "Past history",
    gms: "Allergies",
    twzl: "Photo and text information",
    jzys: "Serving doctor",
    zs: "Chief complaint",
    xbs: "History of present illness",
    zd: "Diagnosis",
    zdbc: "Diagnostic supplement",
    clyj: "pinion on diagnosis",
    jc: "Examination",
    jy: "Inspection ",
    qmy: "Buy Some Medicine",
    pj: "Evaluation",
    tjpj:  "Submit evaluation",
    qsrndysdpj: "Please enter Evaluation of doctors",
    tjjzr: "Add a patient",
    xingming: "Name",
    jrzkmz: "Today’s specialist out-patient department",
    mzsj: "Outpatient time",
    xzsj: "Select the time",
    xzjzr: "Choose a patient",
    bqms: "Disease description",
    qsrbqms:"Please input disease description",
    jibing: "Disease ",
    fbsj: "The time of onset of the symptom",
    yfydyw: "The medicine that you have been taken",
    tpzl: "Picture information",
    hyd: "Laboratory sheet",
    yxddzl: "A maximum of 10 （image,etc)",
    tjsq: "Submit applications",
    ypqd: "Drug list",
    ypm: "Drug name ",
    sl: "Quantity",
    jzrgl: "Atient management",
    dysdpj:  "Evaluation of doctors",
    pjxq: "Detail of evaluation",
    sy: "Nephritis",
    dx: "Epilepsy",
    cz: "Operation",
    qt: "Other",
    qrtj: "Confirm to add",
    xz:  "Choose",
    ywgm: "Drug allergy",
    qms: "Penicillin",
    tplkss: "Cephalosporin",
    psfkds: "Tetanus antitoxin",
    plky:  "Procaine",
    dky: "Dicaine",
    halyw:  "Sulfonamides",
    wssb1: "Vitamin B1",
    fypa:  "Urografin",
    aspl: "Aspirin",
    swgm: "Food allergy",
    mg: "Mango",
    nn: "Milk",
    hx: "Seafood",
    sun: "Bamboo shoot",
    xg: "Shiitake mushroom",
    hg: "Cucumber",
    hf: "Pollen",
    hq: "Paint",
    pm: "Fur",
    hzp: "Cosmetic",
    jbs: "Disease history",
    xzb: "Heart Disease",
    crb: "Infectious disease",
    fjh: "Pulmonary tuberculosis",
    bdxgy: "Viral hepatitis",
    xxcb: "Schistosomiasis",
    lb: "Gonorrhea",
    sss: "History of surgery",
    lnss: "Craniocerebral surgery",
    jbss: "Neck surgery",
    xbss: "Chest surgery",
    fbss: "Abdominal surgery",
    bbss: "Back surgery",
    szss: "Limb surgery",
    gz: "Fracture",
    tbws: "Head injury",
    ss: "Burn",
    jjss: "Tendon injury",
    pfrzzss: "Skin Soft Tissue Injury",
    dks: "Chop wound",
    dcs: "Stab wound",
    dqr:"To be confirmed",
    wzmy:"Visit an expert ",
    qxznyjzdks:"Lease select a department.",
    qyynyjzdym:"Please make an appointment with an expert",
    symy:"All the experts",
    530:"30th May",
    zwjj: "No brief introduction.",
    sc: "Specialties ",
    mzlb: "Outpatient list",
    jzrlb: "Patient list",
    cfddlb: 'Prescription order',
    cfddjl: "Prescription order record",
    wzjl: "Inquiry record",
    wtj: "Unsubmitted",
    dzf: "Pending payment",
    djz: "Pending visit",
    yqx: "Cancel successfully",
    zfcs: "Overtime payment",
    sqtk: "Request a refund",
    tytk: "Refund agreed",
    jjtk: "Refund denied",
    tkcg: "Refund successfully ",
    tksb: "Refund failed",
    hzxm: "Patient name",
    yyh: "Reservation number",
    zkxq: "Unfold",
    qmpdrs: "The number of people queuing in front of you ",
    cg20fzwzf: "If payment exceeds more than 20 minutes, the order will be cancelled automatically.",
    scbl: "Upload the medical record ",
    fcmy: "Very satisfied",
    hh: "Good",
    hbc: "Not bad ",
    yb: "So-so",
    dgj: "To be improved",
    qqha: "Kind and nice ",
    nxxz: "Katient and careful ",
    jyff: "Experienced ",
    yssg: "Have excellent leechcraft",
    ydgs: "Have noble medical ethics",
    zyjd: "Expertise recommendation",
    rzfz: "Conscientious and responsible",
    hfjs: "Give prompt reply",
    qxbtk: "Withdrawal and refund.",
    qxzqxyy:"Please select the reason for withdrawal.",
    ddsjc: "The waiting time is long.  ",
    spwflj: "The video connection is failed.",
    spzlc: "The video quality is poor.",
    xcys: "I’ve selected the wrong doctor.",
    lsys: "I’ve got an emergency.",
    ycsj: "I’ve got the wrong time. ",
    qxsm: "Reason for withdrawal",
    yyjztjr: "Please note:  The hospital will process your refund within 3 working days from the date of submission.",
    ryyw: "If you have any questions, please contact the hospital hotline.",
    smxzzshn: "You can see see a doctor at home by scanning the two-dimensional barcode and download the APP “palm Henan Province People's Hospital Internet hospital”. ",
    bs: "History ",
    txxx: "Fill in your information.",
    qxqmszz: "Please describe your condition.",
    qz20fznwcfk: "Please complete the payment within 20 minutes. Otherwise the appointment will be withdrawl automatically.",
    zfcg: "Payment success",
    nysqcg: "Your application has been submitted  successfully. Please wait for the expert patiently.",
    fhsqlb: "Back to application list ",
    zfswcg: "Payment processing ",
    skf: "Payee",
    yfje: "Account payable ",
    cxzf: "Make the payment again ",
    qzxdkdymwczf: "Please complete the payment on the newly opened page",
    qwgb:"Do not close the window before payment is completed.",
    fkydwtqlxkf: "If you have any questions about the payment, please contact customer service.",
    fhxzqtzffs: "Back to choose other payment methods",
    fkcg: "Payment success",
    fkywt: "I have questions about the payment.",
    fkydwt: "Any questions about the payment？",
    yebz: "Insufficient account balance (example: you have insufficient bank balance, the amount exceeds your credit card limit, your Alipay account balance is not enough etc.) We recommend you switch to other cards or you can have others to complete the payment if it is emergent.",
    yhkedcx: "The amount exceeds your bank card limit per purchase/day/month.",
    jynhk: "We recommend you switch to other cards or payment methods.",
    nxzxykkjzf: "You have chosen   quick disbursement by credit card, and you can conduct high value payment with certain sellers.",
    hcsdlzfb: "Or you can use the Alipay to complete the payment. You can also have others to complete the payment if it is emergent.",
    wlxtfm: "The network system is busy, please try again later.",
    wxdd:  "If you’ve got invalid orders or repeat payment, please go to【consultation center】 to check the order state first; if the order state is 【pending payment】，then you need to make the payment again; if the order state is 【application complete】,  it means you have already made the payment.",
    bcsm: "Additional information",
    tjtp: "Add pictures ",
    wxsm: "Scan the code by your mobile phone and upload photos",
    bdsc: "Upload a local file ",
    xc: "Asthma ",
    gxzz: "Hyperlipidemia",
    hnsxz: "Hyperuricemia",
    gxy: "Hypertension",
    tnb: "Diabetes",
    ncz: "Cerebral stroke",
    yuan:"Yuan",
    xiugai:"Update",
    bc:"Save",
    jzlc:"Medical process" ,
    qxyy:"The reason for withdrawal" ,
    fy:"Fee",
    qdyscm:"Are you sure you want to delete？" ,
    ts:"Prompt" ,
    nh:"Hello" ,
    dl:"Login",
    zc:"Register",
    dlzc:"Login/Register" ,
    tc:"Exit" ,
    qxxmszz:"Please describe your condition, symptom, the time of the onset of the symptom and the medicine that you have been taken before." ,
    qd:"OK" ,
    qx:"Cancel" ,
    bcg500:"No more than 500 words"  ,
    tz:"Suspend medical service" ,
    gystz:"The doctor has suspended medical service. You cannot register now."   ,
    gyswpb:"The doctor has no scheduling for the time being. You cannot register now.",
    zfy:"Total fee"    ,
    qxzzffs:"Please choose the payment method."  ,
    zfbzf:"Alipay"  ,
    wxzf:"WeChat Pay"   ,
    nycstjnr:"Submission time-out. Please register again."    ,
    yzmdl:"Verification code login  "   ,
    qsrxm:"Please enter your name",
    qsrsfzh:"Please enter your Identity card number",
    qsrsjh:"Phone number"   ,
    qsryzm:"Please enter your Verification code",
    qsrdxyzm:"Verification code"  ,
    hqyzm:"vertificode" ,
    qsrzqdsjh:"Please enter the correct mobile phone number."   ,
    dlcg:"Login successfully",
    nywczf:"You have completed the payment." ,
    qgbzfck:"Please close the payment window and return to the original page."  ,
    gbck:"Close"  ,
    dksjzfb:"Open your mobile alipay account."   ,
    sysjxfk:"Scan and continue to pay."   ,
    dkwxsys:"Open WeChat “scan” to complete the payment"  ,
    djgbck:"Click to close window and continue the consultation"   ,
    nyzfcs:"Payment time-out, please reapply."   ,
    zfsb:"Payment failure"   ,
    xszf:"Online payment" ,
    ygh:"Your number is overdue."  ,
    dtj:"To submit" ,
    bj:"Edit "   ,
    shanchu:"Delete"   ,
    qrscjzr:"Confirm to delete the patient",
    bltp:"Medical images " ,
    ckxq:"View details" ,
    ddh:"Order number"  ,
    qxzyy:"Please select reasons"  ,
    ysjhs:"When the doctor is calling the number, please ensure your communication tool is working. If your number is overdue, you can click again to wait for the call." ,
    tkz:"Refund processing" ,
    ddqrtk:"Waiting for refund confirmation"  ,
    hzyqx:"The consultation has been cancelled and the money will be returned to your account on the same way." ,
    cxhz:"Re - waiting" ,
    bzcgwjlx:"Do not support the file type for uploading."  ,
    yf:"Direction",
    smewm:"Scanning two-dimensional code",
    kstwzx:"Start a graphic and text consultation",
    wu:"Nothing",
    zwpb:"No scheduling",
    dizhi:"Address",
    dizhi_value:"No. five, No. 7, latitude road, Jinshui District, Henan, Zhengzhou（450040）",
    dianhua:"Central exchange",
    dianhua_value:"Emergency call: 0371-65580120  call: 0371-65580014 (switchboard)",
    bqsy:"Copyright",
    bqsy_value:" Henan Province People's Hospital All rights reserved. ",
    jszc:"Technical Support",
    yyewmmc:"Hospital qr code name",
    lxyx:"Contact Emai",
    jszc_value:"Hangzhou zhuojian information technology co. LTD",
    ygq:"Expired",
    qdqhyym:"Are you sure to toggle the language?",
    tishi:"Warm Tips",
    qdlndzh:"Please login",
    zzqx: "Canceling, Please Wait",
    hlwyy: "Internet hospital",
}



// WEBPACK FOOTER //
// ./src/assets/common/lang/en.js